import i18next from 'i18next';

i18next.addResources('es', 'ReportAudit', {
  view: 'Ver reporte',
  goBack: 'Volver',
  createdAt: 'Fecha de creación',
  author: 'Creador/a',
  actions: 'Acciones'
});
